import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";

/** Request a password-reset email. Always resolves 200 (no user enumeration). */
export function useForgotPassword() {
  return useMutation<void, ApiError, { email: string }>({
    mutationFn: async (input) => {
      await apiFetch<{ ok: true }>("/auth/forgot-password", {
        method: "POST",
        body: input,
      });
    },
  });
}
